import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import Col from "react-bootstrap/Col";
import { useState } from "react";

function Carousel() {
  return (
    <>
      <Col md={7}>
        <div className="login-main-right bg-white p-5 mt-5 mb-5">
          <AuthScreenSlider />
        </div>
      </Col>
    </>
  );
}

function AuthScreenSlider() {
  const [currentSlide, setCurrentSlide] = useState(0);

  // sliderRef = DOM ref, instanceRef.current = slider instance
  const [sliderRef, instanceRef] = useKeenSlider({
    loop: true,
    slides: { perView: 1 },
    slideChanged(s) {
      setCurrentSlide(s.track.details.rel);
    },
    initial: 0,
  });

  return (
    <>
      <div ref={sliderRef} className="keen-slider">
        <div className="keen-slider__slide">
          <Slide imgSrc="/img/vaghf1.webp" imgAlt="LOGO">
            وقف هدیه ای ماندگار
          </Slide>
        </div>
        <div className="keen-slider__slide">
          <Slide imgSrc="/img/vaghf2.webp" imgAlt="LOGO">
            وقف بارش باران سخاوت
          </Slide>
        </div>
        <div className="keen-slider__slide">
          <Slide imgSrc="/img/vaghf3.webp" imgAlt="LOGO">
            وقف آرامش فردا
          </Slide>
        </div>
      </div>

      {/* Dots navigation */}
      <div
        style={{
          marginTop: "1rem",
          display: "flex",
          justifyContent: "center",
          gap: "10px",
        }}
      >
        {[0, 1, 2].map((idx) => (
          <button
            key={idx}
            onClick={() => instanceRef.current?.moveToIdx(idx)}
            style={{
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              border: "none",
              backgroundColor: currentSlide === idx ? "#333" : "#ccc",
              cursor: "pointer",
              padding: 0,
            }}
            aria-label={`Go to slide ${idx + 1}`}
          />
        ))}
      </div>
    </>
  );
}

function Slide({ imgSrc, imgAlt, heading, children }) {
  return (
    <div className="item">
      <div
        className="carousel-login-card text-center"
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            width: "265px",
            height: "350px",
          }}
        >
          <img
            src={imgSrc}
            style={{ objectFit: "cover", width: "100%", height: "100%" }}
            className="img-fluid"
            alt={imgAlt}
          />
        </div>
        <h5 className="mt-5 mb-3">{heading}</h5>
        <p className="mb-4">{children}</p>
      </div>
    </div>
  );
}

export default Carousel;
